import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useUser } from "../Contexts/UserContext";
import logo from "../Images/logo.png";
import { useHeader } from "../Contexts/HeaderContext";
import { Squeeze as Hamburger } from "hamburger-react";
import WeatherWidget from "./WeatherWidget";
import { Collapse } from "bootstrap";
import { API_URL } from "../Helpers/api";

const Header = () => {
  const { headerRef } = useHeader();
  const [show, setShow] = useState(false);
  const { user, setUser } = useUser();

  useEffect(() => {
    const collapseEl = document.getElementById("navbarNav");
    if (!collapseEl) return;

    const onShown = () => setShow(true);
    const onHidden = () => setShow(false);

    collapseEl.addEventListener("shown.bs.collapse", onShown);
    collapseEl.addEventListener("hidden.bs.collapse", onHidden);

    return () => {
      collapseEl.removeEventListener("shown.bs.collapse", onShown);
      collapseEl.removeEventListener("hidden.bs.collapse", onHidden);
    };
  }, []);

  const closeMenu = () => {
    const collapseEl = document.getElementById("navbarNav");
    const bsCollapse = Collapse.getInstance(collapseEl);
    if (bsCollapse && collapseEl.classList.contains("show")) {
      bsCollapse.hide();
    }
  };

  const handleClick = () => {
    const collapseEl = document.getElementById("navbarNav");
    if (!collapseEl) return;

    let bsCollapse = Collapse.getInstance(collapseEl);
    if (!bsCollapse) {
      bsCollapse = new Collapse(collapseEl, { toggle: false });
    }

    const isOpen = collapseEl.classList.contains("show");

    if (isOpen) {
      bsCollapse.hide();
    } else {
      bsCollapse.show();
    }
  };

  const handleUser = () => {
    if (user) {
      window.location.href = `${API_URL}/auth/signout?redirect=${encodeURIComponent(window.location.origin)}`;
      return setUser(null);
    } else {
      window.location.href = `${API_URL}/auth/google`;
    }
  };

  return (
    <header ref={headerRef} id="header" className={`z-4 fixed-top shadow`}>
      <div className={`navbar navbar-expand-xxl bg-body-tertiary`}>
        <div className="container-fluid bg-body-tertiary text-center">
          <WeatherWidget />
          <Link className="navbar-brand d-flex align-items-center p-0" to={"/"}>
            <div className="d-flex mx-auto align-items-center">
              <img
                src={logo}
                alt="Bella Unión - La triple frontera más austral"
                style={{ height: "3.5rem" }}
                className="ms-3"
              />
              <div className="ms-2 ps-3 text-start border-1 border-start">
                <span className=" fs-3 mb-0">
                  Bella Unión <br /> <span className="d-none">La triple frontera más austral</span>
                </span>
                <span className="d-none d-md-block fs-6 fs-md-5">La triple frontera más austral</span>
              </div>
            </div>
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            aria-label="Toggle navigation"
            onClick={handleClick}
          >
            <Hamburger toggled={show} size={20} />
          </button>
          <div
            style={{ fontSize: "0.7rem" }}
            className="position-absolute d-flex align-items-center top-0 end-0 m-1"
          >
            {user && (
              <button onClick={() => handleUser()} className="btn btn-sm btn-danger">
                Logout
              </button>
            )}
          </div>
          <div class="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto align-items-center">
              <li className="nav-item">
                <NavLink onClick={handleClick} className="nav-link" to={"/"}>
                  Inicio
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink onClick={closeMenu} className="nav-link" to={"/area-protegida"}>
                  Área Protegida
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink onClick={closeMenu} className="nav-link" to={"/alojamiento"}>
                  Alojamientos
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink onClick={closeMenu} className="nav-link" to={"/gastronomia"}>
                  Gastronomía
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink onClick={closeMenu} className="nav-link" to={"/actividades"}>
                  Actividades
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink onClick={closeMenu} className="nav-link" to={"/carnaval"}>
                  Carnaval
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink onClick={closeMenu} className="nav-link" to={"/galeria"}>
                  Galería
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink onClick={closeMenu} className="nav-link" to={"/emprendimientos"}>
                  Emprendimientos
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink onClick={closeMenu} className="nav-link" to={"/artigas"}>
                  Explora Artigas
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink onClick={closeMenu} className="nav-link" to={"/contacto"}>
                  Contacto
                </NavLink>
              </li>
              {user?.role === "admin" && (
                <li className="nav-item">
                  <NavLink onClick={closeMenu} className="nav-link" to={"/admin/panel-de-control"}>
                    <b>Panel de Control</b>
                  </NavLink>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
